import React, { useContext, useEffect, useState } from 'react';
import Application from "../../../StateContext/Application";
import { Cancel32, submit } from '../../../../../public/LoginImages/importimages';
import { toast } from 'react-toastify'; // Import for better user feedback
import './EcsUpdate.css'
import { useLanguage } from '../../../../../lang/langcontext/LanguageContext';
import GooglePagination from '../../../styles/GooglePagination';

const ECSUpdate = () => {
        const { language, toggleLanguage, t } = useLanguage();
    const statecalls = useContext(Application);
    const { FetchFilesForUpdate, saveECSFile } = statecalls;

    // --- State Variables ---
    const [ecsdata, SetECSData] = useState([]);
    const [selectedUniqueIDs, setSelectedUniqueIDs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isMinisterLoggedIn, setIsMinisterLoggedIn] = useState(false);

    // --- Pagination Logic ---
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(ecsdata.length / itemsPerPage);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = ecsdata.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // --- Checkbox Handlers ---

    // Handles individual row selection
    const handleRowCheckboxChange = (uniqueId) => {
        setSelectedUniqueIDs(prevSelected => {
            if (prevSelected.includes(uniqueId)) {
                return prevSelected.filter(id => id !== uniqueId);
            } else {
                return [...prevSelected, uniqueId];
            }
        });
    };

    // Handles select/deselect all for the current page
    const handleMasterCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        const currentUniqueIDs = currentData.map(row => row.UniqueID);

        if (isChecked) {
            setSelectedUniqueIDs(prevSelected => {
                const allSelected = new Set([...prevSelected, ...currentUniqueIDs]);
                return Array.from(allSelected);
            });
        } else {
            setSelectedUniqueIDs(prevSelected =>
                prevSelected.filter(id => !currentUniqueIDs.includes(id))
            );
        }
    };

    // --- Data Fetching and Auth Check ---

    useEffect(() => {
        // const token = localStorage.getItem("AdminName");
        // if (token === 'Minister') {
        //     setIsMinisterLoggedIn(true);
        // } else {
        //     setIsMinisterLoggedIn(false);
        // }

        GetFiles();
    }, []);

    async function GetFiles() {
        try {
            let data = await FetchFilesForUpdate()
            SetECSData(data || [])
        } catch (error) {
            console.log(error);
        }
    }

    // --- Reinitiate Action Handler (The core new logic) ---
    const reinitiateSelected = async () => {
        if (selectedUniqueIDs.length === 0) {
            toast.warning("Please select at least one file to reinitiate.");
            return;
        }

        setLoading(true);
        const adminName = localStorage.getItem("AdminName");

        try {
            const payload = {
                Department: "Admin",
                selectedBills: selectedUniqueIDs.join(','),
                FullName: adminName,
                Role: "Minister",
                type: 'reinitiated',
            };

            // Call the API endpoint
            let response = await saveECSFile(payload);

            toast.success(response.message || "Reinitiation request sent successfully.");

            // Reset state
            setSelectedUniqueIDs([]);
            setCurrentPage(1);
            await GetFiles(); // Refresh the list

        } catch (error) {
            console.error("Reinitiation failed:", error);
            const errorMessage = error.response?.data?.error || error.message || "Failed to reinitiate payment.";
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };


    // return (
    //     <>
    //         <div
    //             style={{
    //                 backgroundColor: "#f4f8fc",
    //                 maxHeight: "90vh",
    //                 overflowY: "auto",
    //                 msOverflowStyle: "none",       // IE & Edge
    //                 scrollbarWidth: "none"         // Firefox
    //             }}
    //             className="no-scrollbar p-4"
    //         >
    //             <h5 className='gradient-text-approval'>ECS Update</h5>

    //             {loading && (
    //                 <div
    //                     style={{
    //                         position: 'fixed',
    //                         top: 0,
    //                         left: 0,
    //                         width: '100vw',
    //                         height: '100vh',
    //                         display: 'flex',
    //                         justifyContent: 'center',
    //                         alignItems: 'center',
    //                         backgroundColor: 'rgba(255, 255, 255, 0.5)',
    //                         zIndex: 9999
    //                     }}
    //                 >
    //                     <div
    //                         style={{
    //                             border: '8px solid #f3f3f3',
    //                             borderTop: '8px solid #3498db',
    //                             borderRadius: '50%',
    //                             width: '60px',
    //                             height: '60px',
    //                             animation: 'spin 1s linear infinite'
    //                         }}
    //                     />
    //                 </div>
    //             )}
    //             <style>
    //                 {`@keyframes spin {0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); }}`}
    //             </style>

    //             {/* Buttons */}
    //             <div className="form-actions-approval">
                    
    //                     <button
    //                         className="btn-approve"
    //                         onClick={reinitiateSelected} // <-- Updated onClick handler
    //                         disabled={loading || selectedUniqueIDs.length === 0} // Disabled if loading or no items selected
    //                         style={{ cursor: (loading || selectedUniqueIDs.length === 0) ? 'not-allowed' : 'pointer' }}
    //                     >
    //                         <img src={submit} alt="Submit" />
    //                         {loading ? 'Processing...' : 'Reinitiate & Pay'}
    //                     </button>
                  
    //             </div>

    //             {/* Table Container (Rest of the component remains the same) */}
    //             <div className="col-12 my-3 text-center">
    //                 <div className="table-responsive">
    //                     <table className="aproval-table">
    //                         <thead>
    //                             <tr>
    //                                 <th style={{ width: "5%" }}>
    //                                     <input
    //                                         type="checkbox"
    //                                         style={{ marginRight: '5px', height: '1.5rem', width: '1.5rem' }}
    //                                         onChange={handleMasterCheckboxChange}
    //                                         checked={
    //                                             currentData.length > 0 &&
    //                                             currentData.every(row => selectedUniqueIDs.includes(row.UniqueID))
    //                                         }
    //                                     />
    //                                 </th>
    //                                 <th className="border border-gray-300 px-4 py-2">Sr.No.</th>
    //                                 <th className="border border-gray-300 px-4 py-2">Unique ID</th>
    //                                 <th className="border border-gray-300 px-4 py-2">Beneficiary Name</th>
    //                                 <th className="border border-gray-300 px-4 py-2">Amount</th>
    //                                 <th className="border border-gray-300 px-4 py-2">Status</th>
    //                                 <th className="border border-gray-300 px-4 py-2">Status Desc</th>
    //                             </tr>
    //                         </thead>
    //                         <tbody>
    //                             {currentData.length > 0 ? (
    //                                 currentData.map((row, index) => (
    //                                     <tr key={row.UniqueID || index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
    //                                         <td>
    //                                             <input
    //                                                 type="checkbox"
    //                                                 style={{ marginRight: '5px', height: '1.5rem', width: '1.5rem' }}
    //                                                 checked={selectedUniqueIDs.includes(row.UniqueID)}
    //                                                 onChange={() => handleRowCheckboxChange(row.UniqueID)}
    //                                             />
    //                                         </td>
    //                                         <td className="border border-gray-300 px-4 py-2">{(currentPage - 1) * itemsPerPage + index + 1}</td>
    //                                         <td className="border border-gray-300 px-4 py-2">{row.UniqueID}</td>
    //                                         <td className="border border-gray-300 px-4 py-2">{row.Vendor_Company_Name}</td>
    //                                         <td className="border border-gray-300 px-4 py-2">{row.TotalAmount}</td>
    //                                         <td className="border border-gray-300 px-4 py-2">{row.Status}</td>
    //                                         <td className="border border-gray-300 px-4 py-2">{row.statusDesc}</td>
    //                                     </tr>
    //                                 ))
    //                             ) : (
    //                                 <tr>
    //                                     <td colSpan="7" style={{ textAlign: "center" }} className='odd-row'>No Data Found</td>
    //                                 </tr>
    //                             )}
    //                         </tbody>
    //                     </table>
    //                 </div>
    //             </div>

    //             {/* Pagination (Styled to match the example) */}
    //             <div style={{
    //                 width: '100%',
    //                 display: 'flex',
    //                 justifyContent: 'space-between',
    //                 height: '3rem',
    //                 alignItems: 'center',
    //                 margin: '10px auto',
    //                 backgroundColor: '#c8e5fc',
    //                 padding: '0px 10px',
    //             }}>
    //                 {/* Pagination Info */}
    //                 <div>
    //                     <p style={{ margin: '0px', color: 'black', fontWeight: '400' }}>
    //                         Showing {Math.min(indexOfFirstItem + 1, ecsdata.length)} to{" "}
    //                         {Math.min(indexOfLastItem, ecsdata.length)} of {ecsdata.length} entries
    //                     </p>
    //                 </div>

    //                 {/* Pagination Controls */}
    //                 <div className="pagination-controls">
    //                     {/* First Page */}
    //                     <button
    //                         onClick={() => handlePageChange(1)}
    //                         disabled={currentPage === 1}
    //                         className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
    //                     >
    //                         &laquo;
    //                     </button>

    //                     {/* Previous */}
    //                     <button
    //                         onClick={() => handlePageChange(currentPage - 1)}
    //                         disabled={currentPage === 1}
    //                         className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
    //                     >
    //                         &lt;
    //                     </button>

    //                     {/* Current Page Highlight */}
    //                     <button
    //                         className="pagination-btn active"
    //                     >
    //                         {currentPage}
    //                     </button>

    //                     {/* Next */}
    //                     <button
    //                         onClick={() => handlePageChange(currentPage + 1)}
    //                         disabled={currentPage === totalPages}
    //                         className={`pagination-btn ${currentPage === totalPages ? "disabled" : ""}`}
    //                     >
    //                         &gt;
    //                     </button>

    //                     {/* Last Page */}
    //                     <button
    //                         onClick={() => handlePageChange(totalPages)}
    //                         disabled={currentPage === totalPages}
    //                         className={`pagination-btn ${currentPage === totalPages ? "disabled" : ""}`}
    //                     >
    //                         &raquo;
    //                     </button>
    //                 </div>
    //             </div>
    //         </div>
    //     </>
    // )
    return (
            <>
                <div
                    style={{
                        backgroundColor: "#f4f8fc",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        msOverflowStyle: "none",       // IE & Edge
                        scrollbarWidth: "none"         // Firefox
                    }}
                    className="no-scrollbar p-4"
                >
                    <h5 className='gradient-text-approval'>{t("ECS Update")}</h5>
    
                    {loading && (
                        <div
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100vw',
                                height: '100vh',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                zIndex: 9999
                            }}
                        >
                            <div
                                style={{
                                    border: '8px solid #f3f3f3',
                                    borderTop: '8px solid #3498db',
                                    borderRadius: '50%',
                                    width: '60px',
                                    height: '60px',
                                    animation: 'spin 1s linear infinite'
                                }}
                            />
                        </div>
                    )}
                    <style>
                        {`@keyframes spin {0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); }}`}
                    </style>
    
                    {/* Buttons */}
                    <div className="form-actions-approval">
                        
                            <button
                                className="btn-approve"
                                onClick={reinitiateSelected} // <-- Updated onClick handler
                                disabled={loading || selectedUniqueIDs.length === 0} // Disabled if loading or no items selected
                                style={{ cursor: (loading || selectedUniqueIDs.length === 0) ? 'not-allowed' : 'pointer' }}
                            >
                                <img src={submit} alt="Submit" />
                                {loading ? 'Processing...' : 'Reinitiate & Pay'}
                            </button>
                      
                    </div>
    
                    {/* Table Container (Rest of the component remains the same) */}
                    <div className="col-12 my-3 text-center">
                        <div className="table-responsive">
                            <table className="aproval-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: "5%" ,fontSize:"18px" }}>
                                            <input
                                                type="checkbox"
                                                style={{ marginRight: '5px', height: '1.5rem', width: '1.5rem' }}
                                                onChange={handleMasterCheckboxChange}
                                                checked={
                                                    currentData.length > 0 &&
                                                    currentData.every(row => selectedUniqueIDs.includes(row.UniqueID))
                                                }
                                            />
                                        </th>
                                        <th style={{fontSize:"18px"}} className="border border-gray-300 px-4 py-2">{t("Sr.No.")}</th>
                                        <th style={{fontSize:"18px"}} className="border border-gray-300 px-4 py-2">{t("Unique ID")}</th>
                                        <th style={{fontSize:"18px"}} className="border border-gray-300 px-4 py-2">{t("Beneficiary Name")}</th>
                                        <th style={{fontSize:"18px"}} className="border border-gray-300 px-4 py-2">{t("Amount")}</th>
                                        <th style={{fontSize:"18px"}} className="border border-gray-300 px-4 py-2">{t("Status")}</th>
                                        <th style={{fontSize:"18px"}} className="border border-gray-300 px-4 py-2">{t("Status Desc")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.length > 0 ? (
                                        currentData.map((row, index) => (
                                            <tr key={row.UniqueID || index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                                                <td style={{fontSize:"18px"}}>
                                                    <input
                                                        type="checkbox"
                                                        style={{ marginRight: '5px', height: '1.5rem', width: '1.5rem' }}
                                                        checked={selectedUniqueIDs.includes(row.UniqueID)}
                                                        onChange={() => handleRowCheckboxChange(row.UniqueID)}
                                                    />
                                                </td>
                                                <td style={{fontSize:"18px"}} className="border border-gray-300 px-4 py-2">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                                <td style={{fontSize:"18px"}} className="border border-gray-300 px-4 py-2">{row.UniqueID}</td>
                                                <td style={{fontSize:"18px"}} className="border border-gray-300 px-4 py-2">{row.Vendor_Company_Name}</td>
                                                <td style={{fontSize:"18px"}} className="border border-gray-300 px-4 py-2">{row.TotalAmount}</td>
                                                <td style={{fontSize:"18px"}} className="border border-gray-300 px-4 py-2">{row.Status}</td>
                                                <td style={{fontSize:"18px"}} className="border border-gray-300 px-4 py-2">{row.statusDesc}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: "center" }} className='odd-row'>{t("No Data Found")}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "15px",
                        padding: "10px",
                        backgroundColor: "#c8e5fc",
                    }}
                >
                    <div>
                        <p style={{ margin: 0 }}>
                            {t("Showing")}{" "}
                            {ecsdata.length === 0 ? 0 : indexOfFirstItem + 1}{" "}
                            {t("to")}{" "}
                            {Math.min(indexOfLastItem, ecsdata.length)}{" "}
                            {t("of")} {ecsdata.length} {t("entries")}
                        </p>
                    </div>
 
                    <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                </div>
    
                    {/* Pagination (Styled to match the example) */}
                    {/* <div style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        height: '3rem',
                        alignItems: 'center',
                        margin: '10px auto',
                        backgroundColor: '#c8e5fc',
                        padding: '0px 10px',
                    }}>
                        <div>
                            <p style={{ margin: '0px', color: 'black', fontWeight: '400' }}>
                                {t("Showing")} {Math.min(indexOfFirstItem + 1, ecsdata.length)} {t("to")}{" "}
                                {Math.min(indexOfLastItem, ecsdata.length)} {t("of")} {ecsdata.length} {t("entries")}
                            </p>
                        </div>
    
                        <div className="pagination-controls">
                            <button
                                onClick={() => handlePageChange(1)}
                                disabled={currentPage === 1}
                                className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
                            >
                                &laquo;
                            </button>
    
                            <button
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                                className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
                            >
                                &lt;
                            </button>
    
                            <button
                                className="pagination-btn active"
                            >
                                {currentPage}
                            </button>
    
                            <button
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                                className={`pagination-btn ${currentPage === totalPages ? "disabled" : ""}`}
                            >
                                &gt;
                            </button>
    
                            <button
                                onClick={() => handlePageChange(totalPages)}
                                disabled={currentPage === totalPages}
                                className={`pagination-btn ${currentPage === totalPages ? "disabled" : ""}`}
                            >
                                &raquo;
                            </button>
                        </div>
                    </div> */}
                </div>
            </>
        )
}

export default ECSUpdate